import { useMemo } from 'react';
import {
    useArealplanDomains,
    usePlanbehandlingDomains,
    domainOptions,
    type Domains,
} from '@origo/planregister';
import type { SelectOption } from '../types';

function toOptions<F extends string>(domains: Partial<Domains<F>> | undefined, field: F): SelectOption[] {
    return domainOptions(domains, field).map(e => ({ value: e.code, label: e.label }));
}

/**
 * Kodeliste-options for Selects, hentet fra tjenestens coded value domains
 * (#13199/#13211, #14407). Visningstekstene eies av tjenesten — ingen
 * hardkodede kodelister i appen.
 */
export function useCodelistOptions() {
    const arealplan = useArealplanDomains();
    const behandling = usePlanbehandlingDomains();
    const { data: domains } = arealplan;
    const { data: behandlingDomains } = behandling;
    const isLoading = arealplan.isLoading || behandling.isLoading;
    const isError = arealplan.isError || behandling.isError;
    return useMemo(
        () => ({
            domains,
            behandlingDomains,
            isLoading,
            isError,
            plantype: toOptions(domains, 'plantype'),
            planstatus: toOptions(domains, 'planstatus'),
            lovreferanse: toOptions(domains, 'lovreferanse'),
            forslagsstillerType: toOptions(domains, 'forslagsstillerType'),
            planbehandlingtype: toOptions(behandlingDomains, 'planbehandlingtype'),
        }),
        [domains, behandlingDomains, isLoading, isError]
    );
}
